export const SHELL_DISABLED_STORAGE_KEY = 'shellDisabled'

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

export type ReadShellDisabledEnv = {
  search?: string
  isTop?: boolean
  storage?: StorageLike | null
}

function readWindowEnv(): Required<
  Pick<ReadShellDisabledEnv, 'search' | 'isTop'>
> & {
  storage: StorageLike | null
} {
  if (typeof window === 'undefined') {
    return { search: '', isTop: true, storage: null }
  }

  return {
    search: window.location.search,
    isTop: window.self === window.top,
    storage: window.sessionStorage
  }
}

/**
 * Library iframes always set `shellDisabled=true`. Next's router.query is empty
 * on the first paint, so read the URL (and persist to sessionStorage) rather
 * than waiting on hydration. In-iframe navigations that drop the query still
 * count as hosted via the stored flag.
 */
export function readShellDisabled(env: ReadShellDisabledEnv = {}): boolean {
  const fallback = readWindowEnv()
  const search = env.search ?? fallback.search
  const isTop = env.isTop ?? fallback.isTop
  const storage = env.storage !== undefined ? env.storage : fallback.storage

  const queryParam = new URLSearchParams(search).get('shellDisabled')

  if (queryParam !== null) {
    const isDisabled = queryParam === 'true'
    storage?.setItem(SHELL_DISABLED_STORAGE_KEY, String(isDisabled))
    return isDisabled
  }

  if (isTop) {
    storage?.removeItem(SHELL_DISABLED_STORAGE_KEY)
    return false
  }

  return storage?.getItem(SHELL_DISABLED_STORAGE_KEY) === 'true'
}
